import React__default from 'react';

var MobileLobbyMainCont = function (_a) {
    var children = _a.children, background = _a.background;
    return (React__default.createElement("div", { className: 'lobby-wr', style: background ? { backgroundImage: "url(".concat(background, ")") } : {} },
        React__default.createElement("div", { className: 'lobby-list-wr' },
            React__default.createElement("div", { className: 'lobby-list-wr-holder' },
                React__default.createElement("div", { className: 'scrollable-container' }, children)))));
};

export { MobileLobbyMainCont };
